import * as Sentry from '@sentry/react';

type Props = {
  children: React.ReactNode;
  environment: string;
};

export function ErrorBoundary({ children, environment }: Props) {
  const client = new Sentry.BrowserClient({
    dsn: 'https://54667884856b927e2e4945f647885304@sentry10.bynder.cloud/4259',
    transport: Sentry.makeFetchTransport,
    stackParser: Sentry.defaultStackParser,
    integrations: [],
    environment,
  });
  const scope = new Sentry.Scope();
  scope.setClient(client);
  client.init();

  return (
    <Sentry.ErrorBoundary onError={(error) => scope.captureException(error)}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
